import React from 'react'
import Attachment from '../Stream/Components/Attachment'
import { Modal, Button, Spinner } from 'react-bootstrap'

export default function SendAttachmentModal({
  showFile,
  isSending,
  attachment,
  invalidAttachment,

  handleCancel,
  handleAttachment,
  handleSetAttachment,
}) {
  return (
    <Modal show={showFile} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Send a File</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {invalidAttachment && <div className="alert alert-danger">Please select a file.</div>}

        <Attachment selected={handleSetAttachment} />
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleAttachment}
          disabled={isSending || !attachment}
          variant="primary"
        >
          {isSending ? <Spinner size='sm' animation="border" role="status" /> : 'Send File'}
        </Button>

        <Button disabled={isSending} variant="secondary" onClick={handleCancel}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
